import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {TopnavbarComponent} from "./topnavbar.component";

@NgModule({
    declarations: [TopnavbarComponent],
    imports     : [BrowserModule],
    exports     : [TopnavbarComponent],
})

export class TopnavbarModule {}


// WEBPACK FOOTER //
// ./src/app/components/common/topnavbar/topnavbar.module.ts